import React, { useState } from 'react'
import { Alert as LibAlert } from 'reactstrap'
import './Alert.scss'

const Alert = (props) => {
  const [visible, setVisible] = useState(true)
  const onDismiss = () => {
    if (props.dismiss) {
      setVisible(false)
    }
  }
  const { dismiss, ...passThrough } = props
  const className = 'Alert' + (props.className ? ' ' + props.className : '')
  return (
    <LibAlert className={className} {...passThrough} isOpen={visible} onClick={onDismiss}>
      {props.children}
    </LibAlert>
  )
}

export default Alert
